import { createI18n } from 'next-international';

import type { Locale } from './list';
import type { TranslationsWithParameters } from './types';

/**
 * Copy lives in one TypeScript file per locale. English is complete; the
 * others may be partial and fall back to English per key (see `_app.tsx`).
 */
export { LOCALES, type Locale } from './list';

const locales = {
	en: () => import('./en'),
	fr: () => import('./fr'),
	de: () => import('./de'),
	es: () => import('./es'),
	it: () => import('./it'),
	pt: () => import('./pt'),
} as const;

export const {
	useI18n,
	useScopedI18n,
	I18nProvider,
	useChangeLocale,
	defineLocale,
	getLocaleProps,
	useCurrentLocale,
} = createI18n<typeof locales, Record<Locale, TranslationsWithParameters>>(
	locales,
);
